import React from "react";
import { Typography } from "antd";
import textStyles from "../../styles/Custom/Typography.module.css";
import ReceptionistCountBadge from "./ReceptionistCountBadge";
import styles from "./ReceptionistCommon.module.css";

const ReceptionistPageTitle = ({ children, count }) => (
  <div className={styles.pageTitleRow}>
    <Typography className={textStyles.h6}>{children}</Typography>
    <ReceptionistCountBadge count={count} />
  </div>
);

export default ReceptionistPageTitle;
